export default __webpack_public_path__ + "static/media/calls.18d65127.mp3";